module.exports = __webpack_public_path__ + "img/Dantam Hair 34.b64876cb.jpg";